define.alias("shared/components/shared/post/secondary/hashtag-suggestions/table", "media/components/shared/post/secondary/hashtag-suggestions/table");